// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"65f4f464cb90d34548dd","811":"a81b125d18c6b249a862"}[chunkId] + ".js");